<template>
  <img alt="Vue logo" src="./assets/logo.png">
  <RandomDrawer />
</template>

<script>
import RandomDrawer from './components/RandomDrawer.vue';

export default {
  name: 'App',
  components: {
    RandomDrawer
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
